import setup from "./setup";
const getIsSDKTrackings = () => {
  var _JSON$parse;
  return (_JSON$parse = JSON.parse(localStorage.getItem("@mobi/analytics"))) === null || _JSON$parse === void 0 ? void 0 : _JSON$parse.isSDKTrackings;
};
const track = payload => {
  const isSDKTrackings = getIsSDKTrackings();
  return setup({
    isSDKTrackings
  }).then(_ => {
    if (isSDKTrackings) {
      window.TrackAnalytics.Track({
        analytics: payload
      });
    } else {
      window.analyticsData = payload;
      window._frameworkDA.Track();
    }
    console.log("%c @analytics/ga - track", "color: red", payload);
  });
};
const page = payload => {
  const isSDKTrackings = getIsSDKTrackings();
  return setup({
    isSDKTrackings
  }).then(_ => {
    if (isSDKTrackings) {
      window.TrackAnalytics.Track({
        analytics: payload
      });
    } else {
      window.analyticsData = payload;
      window._frameworkDA.Track();
    }
    console.log("%c @analytics/ga - page view", "color: red", payload);
  });
};
export default {
  track,
  page
};